import { render, staticRenderFns } from "./DriveFileUploader.vue?vue&type=template&id=bfad954e&scoped=true"
import script from "./DriveFileUploader.vue?vue&type=script&lang=js"
export * from "./DriveFileUploader.vue?vue&type=script&lang=js"
import style0 from "./DriveFileUploader.vue?vue&type=style&index=0&id=bfad954e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfad954e",
  null
  
)

export default component.exports